import { dashBoard } from '@/axios'

export default {
  getAllStats () {
    return dashBoard().get('merchant/store-statistics/my-store')
  }
}
